  (function () {
    /*
      Rental product page only:
      Hide linked rental charge variants from the header "Your Bag" popup,
      while keeping them in the actual cart for checkout.
    */
    var rentalMiniBagHiddenVariantIds = [
      47525588238523, // Weekend Surcharge
      47541269823675, // Early Delivery
      47943771488443, // Standard Urgent Delivery
      47943772995771, // Priority Urgent Delivery
      47943792853179, // Standard Return Extension
      47943796097211, // Priority Return Extension
      47939116859579, // 32GB Memory Addon
      47939117285563, // MS Office Addon
      48028946235579, // HDMI Port Addon
      47943498989755, // iPad Cellular Addon
      47943499776187, // iPad Pencil Gen 1 Addon
      48199696548027, // iPad Pencil Gen 2 Addon
      48199699824827, // iPad Pencil USB-C Addon
      47526006063291, // Default Security Deposit
      47994120241339, // Business i5 / Ryzen 5 Security Deposit $400
      47994120339643, // Business i7 / Ryzen 7 Security Deposit $500
      48111443509435, // Business Ultra 5 / Ryzen 5 (New) Security Deposit $600
      48111444099259, // Business Ultra 7 / Ryzen 7 (New) Security Deposit $700
      47939100672187, // Gaming Security Deposit $500
      47939105030331, // Gaming Security Deposit $600
      47939105980603, // Gaming Security Deposit $800
      47939106078907, // Gaming Security Deposit $1000
      48205548290235, // RTX 5050 Security Deposit
      48220729606331, // iMac M1 Security Deposit
      47939187343547, // MacBook Air M1 Security Deposit
      47939187605691, // MacBook Air M2 Security Deposit
      47939187671227, // MacBook Air M4 Security Deposit
      47939188719803, // MacBook Pro M1 Security Deposit
      47939189276859, // MacBook Pro M2 Security Deposit
      47939190161595, // MacBook Pro M1 Pro Security Deposit
      47939191931067, // MacBook Pro M2 Pro Security Deposit
      47939192258747, // MacBook Pro M3 Pro Security Deposit
      47939193307323, // MacBook Pro M4 Pro Security Deposit
      48220744155323, // MacBook Pro M5 Pro Security Deposit
      47940834984123, // iPad 9th Security Deposit
      47940837474491, // iPad Air 5th Security Deposit
      47940838621371, // iPad Pro M1 Security Deposit
      47940843143355  // iPad Pro M2 Security Deposit
    ].map(function (id) {
      return String(id);
    });

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function isRentalMiniBagHiddenItem(item) {
      if (!item) return false;

      var itemId = String(item.id || item.variant_id || '');
      if (rentalMiniBagHiddenVariantIds.indexOf(itemId) !== -1) return true;

      var properties = item.properties || {};
      if (properties['Charge type']) return true;
      if (properties['_rental_hidden_in_bag'] === 'true') return true;

      return false;
    }

    function renderRentalMiniBag(cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      var visibleItems = cart.items.filter(function (item) {
        return !isRentalMiniBagHiddenItem(item);
      });

      document.querySelectorAll('.cart_popup_box').forEach(function (popupBox) {
        var cartItemWrap = popupBox.querySelector('.cart_item_block .cart_item');
        if (!cartItemWrap) return;

        cartItemWrap.innerHTML = '';

        if (!visibleItems.length) {
          var emptyText = cart.item_count > 0
            ? 'Rental charges are linked to the main rental.'
            : 'is currently empty.';

          cartItemWrap.innerHTML = '<div class="item_empty">' + escapeHtml(emptyText) + '</div>';
          return;
        }

        var visibleLimit = 3;
        var visiblePreviewItems = visibleItems.slice(0, visibleLimit);
        var html = '';

        visiblePreviewItems.forEach(function (item, index) {
          var isLastVisibleItem = index === visiblePreviewItems.length - 1 && visibleItems.length <= visibleLimit;
          var quantityText = item.quantity && item.quantity !== 1 ? '<br>x' + escapeHtml(item.quantity) : '';
          var imageHtml = item.image
            ? '<img width="100%" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '">'
            : '<span class="rental-mini-bag-image-placeholder" aria-hidden="true"></span>';

          html +=
            '<figure class="cart_row item defualt_item ' + (isLastVisibleItem ? 'border-none' : '') + '" data-id="' + escapeHtml(item.id || item.variant_id || '') + '" data-line="' + escapeHtml(index + 1) + '">' +
              '<a href="' + escapeHtml(item.url || '/cart') + '">' +
                imageHtml +
                '<figcaption>' + escapeHtml(item.product_title || item.title || '') + quantityText + '</figcaption>' +
              '</a>' +
            '</figure>';
        });

        if (visibleItems.length > visibleLimit) {
          var hiddenVisibleQuantity = visibleItems.slice(visibleLimit).reduce(function (total, item) {
            return total + (Number(item.quantity) || 1);
          }, 0);

          html += '<p class="other_item_hidden">' + hiddenVisibleQuantity + ' other item' + (hiddenVisibleQuantity > 1 ? 's' : '') + ' in bag</p>';
        }

        cartItemWrap.innerHTML = html;
      });
    }

    function refreshRentalMiniBag() {
      fetch('/cart.js?rental_mini_bag=' + Date.now(), {
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load cart');
          return response.json();
        })
        .then(renderRentalMiniBag)
        .catch(function (error) {
          console.warn('Rental mini bag refresh failed:', error);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
      refreshRentalMiniBag();

      document.querySelectorAll('.cart_popup_button').forEach(function (button) {
        button.addEventListener('click', function () {
          window.setTimeout(refreshRentalMiniBag, 150);
        });
      });
    });
  })();
